import { Workout } from "../../libs/workout/types";
import { Exercise as ExerciseFromLib } from "../../libs/exercises/types";

export const getColumns = (isTemplate: boolean) => {
  const WeeksSubColumnsLabels = ["Set"];
  if (isTemplate) {
    return ["Set"];
  }
  return WeeksSubColumnsLabels;
};

export const getExercisesRowsObj = (
  workout: Workout,
  dayIndex: number,
  exercisesLookup?: Map<string, ExerciseFromLib> | null
) => {
  if (!workout.data) return [];

  return workout.data[0].days[dayIndex].exercises.map((exercise, index) => {
    // Resolve muscleDistribution: first from workout data, fallback to exercises DB
    let muscleDistribution = exercise.exercise?.muscleDistribution;
    if ((!muscleDistribution || muscleDistribution.length === 0) && exercisesLookup && exercise.exercise?.id) {
      const fromDb = exercisesLookup.get(String(exercise.exercise.id));
      muscleDistribution = fromDb?.muscleDistribution;
    }

    return {
      name: exercise.exercise?.name,
      specialCategoryId: exercise.exercise?.specialCategoryId,
      muscleDistribution,
      weeks:
        (workout.data &&
          workout.data.map((week) => {
            const currEx = week.days[dayIndex].exercises[index];
            return {
              sets: currEx?.exercise?.sets,
              isCompleted: currEx?.exercise?.completed,
              notes: currEx?.exercise?.notes,
            };
          })) ||
        [],
    };
  });
};
